import script from "./OrderFee.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderFee.vue?vue&type=script&setup=true&lang=js"

import "./OrderFee.vue?vue&type=style&index=0&id=77c2d242&lang=css"

const __exports__ = script;

export default __exports__